  <div class="modal__overlay">
    <div class="modal" [style.marginTop.px]="margin">
      <div class="modal__content">
        <div class="modal__header">
          <a class="modal__close" (click)="closeModal($event)"><span class="ico-remove"></span></a>
          <h2>
            <ng-content select="[modal-header]"></ng-content>
          </h2>
        </div>
        <div class="modal__body">
          <ng-content select="[modal-body]"></ng-content>
        </div>
        <div class="modal__footer">
          <ng-content select="[modal-footer]"></ng-content>
        </div>
      </div>
    </div>
  </div>